module.exports = __webpack_public_path__ + "static/woodside-13f728c218ca172accb4a75eaaa7470e.jpg";